import InlineTable from '../primitives/InlineTable';
import { buildBreadcrumb } from '../lib/breadcrumbFormat';
import {
    buildColumns,
    buildRows,
    parentName,
    pinnedTitleParts,
    excludedTerms,
} from '../lib/tableHelpers';
import type { TableModel, VisualProps, VisualWidget } from '../types';

const NAME_KEY = 'category_name';
const TYPE_LABEL = 'Subcategory';

/** `cat5s_inline_table` — subcategories within a category. */
function buildCat5sTableModel({
    input,
    output,
    title: customTitle,
}: VisualProps): TableModel {
    const columns = buildColumns(input?.order_by);
    return {
        breadcrumb: buildBreadcrumb(output, TYPE_LABEL),
        title: {
            custom: customTitle || undefined,
            parent: parentName(output),
            noun: 'subcategories',
            ...pinnedTitleParts(output, NAME_KEY),
            ...excludedTerms(input, output),
            lifeCycle: input?.life_cycle,
        },
        link: output?.result?.dashboard_url,
        nameColumnHeader: 'Category',
        columns,
        rows: buildRows(output, columns, NAME_KEY),
    };
}

const Cat5sInlineTable = ({
    Frame,
    dense,
    onExcludeRow,
    ...props
}: VisualProps) => (
    <InlineTable
        {...buildCat5sTableModel(props)}
        Frame={Frame}
        dense={dense}
        onExcludeRow={onExcludeRow}
    />
);

const widget: VisualWidget = {
    match: (input) =>
        input?.entity_type === 'category' &&
        input?.entity_relationship === 'cat5s',
    Component: Cat5sInlineTable,
};

export default widget;
